module.exports = __webpack_public_path__ + "static/media/007_intel5_1.a3731c61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/mashery/007_intel5_1.png
// module id = 553
// module chunks = 0